<template>
  <div>
    <RelateBankMovements
      id="relateBank"
      :isOpen.sync="relateMovementPanelOpen"
      v-bind:transactions="transaction"
      v-bind:bankId="bank"
      v-bind:accountId="account"
      v-bind:buttonRelateMovement="buttonRelateMovement"
      v-bind:buttonRelateCategory="buttonRelateCategory"
      @updateTransactions="loadBankTransactions"
      @reset="reset"
      @close="closeRelateMovementPanel" />

    <BankMovementsRelations
      id="bankMovementsRelations"
      :isOpen.sync="movementsRelationsPanelOpen"
      v-bind:transaction="transaction"
      v-bind:bankId="bank"
      v-bind:accountId="account"
      @close="closeMovementsRelationsPanel" />

    <v-flex xs12>
      <div class="elevation-1 text-center paper mb-1">
        <v-tabs v-model="tab" class="mb-2">
          <v-tabs-slider></v-tabs-slider>

          <v-tab class="tab">
            {{ $t('expenses.bankReconciliation.transactions.title') }}
          </v-tab>
          <v-tab class="tab">
            {{ $t('expenses.bankReconciliation.relations.title') }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" class="tabs-items">
          <v-tab-item class="transactions-tab">
            <div class="d-flex justify-end mt-2">
              <div class="firstSelect">
                <Select
                  size="x-large"
                  item-text="name"
                  item-value="_id"
                  :items="banks.data"
                  :disabled="isEmpty(banks.data)"
                  v-model.lazy="bank"
                  :label="$t('expenses.bankReconciliation.transactions.bank')"
                  @change="handleBankChange()"
                  hide-details
                  required
                />
              </div>
              <div>
                <Select
                  size="x-large"
                  item-text="name"
                  item-value="id"
                  :items="accounts.data"
                  :disabled="isEmpty(accounts.data)"
                  v-model.lazy="account"
                  :label="$t('expenses.bankReconciliation.transactions.account')"
                  @change="handleAccountChange()"
                  hide-details
                  required
                />
              </div>
              <div class="ml-4">
                <v-menu
                  ref="datePicker"
                  v-model="datePicker"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="range"
                      label="Rango de fechas"
                      prepend-icon="mdi-calendar"
                      outlined
                      rounded
                      readonly
                      hide-details
                      dense
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dates"
                    :range="true"
                    first-day-of-week="1"
                    :allowed-dates="allowedDates"
                    no-title
                  >
                    <div>
                      <div class="d-flex">
                        <v-btn text color="primary" @click="resetDate">Borrar</v-btn>
                        <v-spacer/>
                        <v-btn text color="grey" @click="datePicker = false">Cancel</v-btn>
                        <v-btn :disabled="dates.length < 2" color="primary" @click="loadBankTransactions()">OK</v-btn>
                      </div>
                    </div>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>

            <div v-if="this.bank && !hasFinerioAccount" class="flex-md-row-reverse flex-sm-column justify-space-between d-sm-flex my-2">
              <div class="d-flex">
                <Button @click="openUploadDialog()">
                  <v-icon size="20px" class="mr-1">mdi-file-upload-outline</v-icon>
                  {{ $t('expenses.bankReconciliation.transactions.buttonUpload') }}
                </Button>
                <!-- <Button :disabled="!table.data.length" @click="openWarningDialog()" class="buttonCompleted">
                  {{ $t('expenses.bankReconciliation.transactions.buttonCompleted') }}
                </Button> -->
              </div>
              <div class="d-flex align-center">
                <div class="ml-3">
                  Total: {{ totalAmountSelected | toFixNumber(2) | numberWithComma | prefix('$') }}
                </div>
                <div class="ml-3">
                  Transacciones seleccionadas: {{ table.selected.length }}
                </div>
                <Button class="ml-2" @click="openTransactionsDialog(true, false)" v-show="table.selected.length > 1" v-if="bankReconciliationPermissions['relate-pay-order']">
                  {{ $t('expenses.bankReconciliation.transactions.buttonRelatedSelectedTransactions') }}
                </Button>
                <Button class="colorButton ml-2" @click="openTransactionsDialog(false, true)" v-show="table.selected.length > 1" v-if="bankReconciliationPermissions['relate-pay-order']">
                  Relacionar categoría
                </Button>
              </div>
            </div>

            <v-data-table
              v-model="table.selected"
              :loading-text="table.title"
              :loading="table.loading"
              :headers="table.headers"
              :items="table.data"
              :server-items-length="table.total"
              @update:options="updateTable"
              :options="table.options"
              :footer-props="{
                'items-per-page-options': [5, 10, 15]
              }"
              show-select
              item-key="_id"
              class="data-table-style"
              >
              <template v-slot:[`header.data-table-select`]="{}">
              </template>
              <template v-slot:[`item.data-table-select`]="{ item, isSelected, select}">
                <v-simple-checkbox
                  v-if="!item.related"
                  :ripple="false"
                  :value="isSelected"
                  @input="select($event)"
                  :style="{ color: isSelected ? 'var(--v-primary-base) !important' : ''}"
                ></v-simple-checkbox>
              </template>
              <template v-slot:[`item.date`]="{ item }">
                <div>
                  {{ $moment(item.date).format('DD/MM/YYYY') }}
                </div>
              </template>
              <template v-slot:[`item.description`]="{ item }">
                <div>
                  {{ item.description }}
                </div>
              </template>
              <template v-slot:[`item.amount`]="{ item }">
                <div v-if="item.isCharge === 'true'">
                  ${{ item.amount | toFix2 | numberWithComma }} {{ item.currency }}
                </div>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <div v-if="!item.related" class="d-flex align-row">
                  <v-btn
                    fab
                    x-small
                    depressed
                    :plain="true"
                    :ripple="false"
                    color="primary"
                    @click="openRelateMovementPanel(item, true, true)"
                    class="mr-1"
                    style="padding-right: 2px;"
                    :disabled="table.selected.length > 1"
                    >
                    <v-icon>$relate</v-icon>
                  </v-btn>
                  <div class="my-auto">
                    <a @click="openRelateMovementPanel(item, true, true)">
                      {{ $t('expenses.bankReconciliation.transactions.relate') }}
                    </a>
                  </div>
                </div>
                <div v-if="item.related && !item.outgoingCategory" class="d-flex align-row">
                  <v-btn
                    fab
                    x-small
                    depressed
                    :plain="true"
                    :ripple="false"
                    color="secondary"
                    dark
                    @click="openMovementsRelationsPanel(item)"
                    class="mr-1"
                    style="padding-right: 2px;"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                  <div class="my-auto">
                    <a @click="openMovementsRelationsPanel(item)">
                      {{ $t('expenses.bankReconciliation.transactions.details') }}
                    </a>
                  </div>
                </div>
                <div v-if="item.related && item.outgoingCategory" class="d-flex align-row">
                  {{ item.outgoingCategory ? item.outgoingCategory.name : ''}}
                </div>
              </template>
            </v-data-table>

            <v-dialog @keydown.esc="uploadDialogOpen=false" v-model="uploadDialogOpen" persistent max-width="600px" class="custom-dialog">
              <v-card>
                <div class="d-flex justify-end">
                  <v-btn
                    fab
                    color="transparent"
                    depressed
                    @click="closeUploadDialog"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
                <v-card-text>
                  <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-success="openPreviewDialog" useCustomSlot>
                    <div class="dz-message" data-dz-message>
                      <span>{{ $t('expenses.bankReconciliation.transactions.dialogUpload.dropzoneText') }}</span>
                    </div>
                  </vue-dropzone>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <Button size="regular" @click="closeUploadDialog()">
                    {{ $t('expenses.bankReconciliation.transactions.dialogUpload.buttonClose') }}
                  </Button>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog @keydown.esc="previewDialogOpen=false" v-model="previewDialogOpen" persistent max-width="900px">
              <v-card>
                <div class="d-flex justify-end">
                  <v-btn
                    fab
                    color="transparent"
                    depressed
                    @click="closePreviewDialog"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
                <v-card-title>
                  <v-icon class="mr-1">mdi-file-eye-outline</v-icon>
                  {{ $t('expenses.bankReconciliation.transactions.dialogPreview.title') }}
                </v-card-title>
                <v-card-text>
                  <v-data-table
                    :loading-text="tablePreviewTransactions.title"
                    :loading="tablePreviewTransactions.loading"
                    :headers="tablePreviewTransactions.headers"
                    :items="tablePreviewTransactions.data"
                    :options="tablePreviewTransactions.options"
                    :footer-props="{
                      'items-per-page-options': [5, 10, 15]
                    }"
                    sort-by="name">
                    <template v-slot:[`item.date`]="{ item }">
                      <div>
                        {{ item['Fecha del apunte'] }}
                      </div>
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                      <div>
                        {{ item['Descripción'] }}
                      </div>
                    </template>
                    <template v-slot:[`item.amount`]="{ item }">
                      <div v-if="item['Importe del débito']!=''">
                        ${{ item['Importe del débito'] | toFix2 | numberWithComma }} {{ item.currency }}
                      </div>
                    </template>
                    <template v-slot:[`item.amount2`]="{ item }">
                      <div v-if="item['Importe de crédito']!=''">
                        ${{ item['Importe de crédito'] | toFix2 | numberWithComma }} {{ item.currency }}
                      </div>
                    </template>
                    <template v-slot:[`item.balance`]="{ item }">
                      <div>
                        ${{ item['Saldo'] | toFix2 | numberWithComma }} {{ item.currency }}
                      </div>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <Button size="large" type="outlined" @click="closePreviewDialog()">
                    {{ $t('expenses.bankReconciliation.transactions.dialogPreview.buttonCancel') }}
                  </Button>
                  <Button size="large" :disabled="isEmpty(tablePreviewTransactions.data)" @click="saveFile">
                    <v-icon size="18px" class="mr-1">$relate</v-icon>
                    {{ $t('expenses.bankReconciliation.transactions.dialogPreview.buttonSend') }} ds
                  </Button>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog @keydown.esc="uploadErrorDialogOpen=false" v-model="uploadErrorDialogOpen" persistent max-width="400px">
              <v-card>
                <div class="d-flex justify-end">
                  <v-btn
                    fab
                    color="transparent"
                    depressed
                    @click="closeUploadErrorDialog()"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
                <v-card-text>
                  <div class="text-center">
                    <v-icon class="alert-icon mb-4">mdi-alert-circle-outline</v-icon>
                    <p class="dialogText">{{ $t('expenses.bankReconciliation.transactions.dialogUploadError.transactionError') }}</p>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <Button size="regular" @click="closeUploadErrorDialog()">
                    {{ $t('expenses.bankReconciliation.transactions.dialogUploadError.buttonClose') }}
                  </Button>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog @keydown.esc="uploadSuccessDialogOpen=false" v-model="uploadSuccessDialogOpen" persistent max-width="400px">
              <v-card>
                <div class="d-flex justify-end">
                  <v-btn
                    fab
                    color="transparent"
                    depressed
                    @click="closeUploadSuccessDialog"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
                <v-card-text>
                  <div class="text-center">
                    <img src="@/assets/check.svg" class="mb-4 successIcon" />
                    <p class="dialogText">{{ $t('expenses.bankReconciliation.transactions.dialogUploadSucess.text') }}</p>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <Button size="regular" @click="closeUploadSuccessDialog()">
                    {{ $t('expenses.bankReconciliation.transactions.dialogUploadSucess.buttonClose') }}
                  </Button>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog @keydown.esc="warningDialogOpen=false" v-model="warningDialogOpen" persistent max-width="453px">
              <v-card>
                <div class="d-flex justify-end">
                  <v-btn
                    fab
                    color="transparent"
                    depressed
                    @click="closeWarningDialog()"
                    class="mr-1 mt-1"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
                <v-card-text class="d-flex flex-column align-center">
                  <v-icon class="alert-icon">mdi-alert-circle-outline</v-icon>
                  <div class="mt-4 text-center">
                    <p class="dialogText">{{ $t('expenses.bankReconciliation.transactions.warningDialog.text') }}</p>
                  </div>
                </v-card-text>
                <v-card-actions class="px-6 justify-space-between">
                  <Button size="small" type="outlined" @click="closeWarningDialog()">
                    {{ $t('expenses.bankReconciliation.transactions.warningDialog.buttonCancel') }}
                  </Button>
                  <Button size="small" @click="completeTransactions()">
                    {{ $t('expenses.bankReconciliation.transactions.warningDialog.buttonConfirm') }}
                  </Button>
                </v-card-actions>
              </v-card>
            </v-dialog>

          </v-tab-item>

          <v-tab-item class="relations-tab">
            <div class="d-flex justify-end mt-2">
              <div class="firstSelect">
                <Select
                  size="x-large"
                  item-text="name"
                  item-value="_id"
                  :items="banks.data"
                  :disabled="isEmpty(banks.data)"
                  v-model.lazy="bank"
                  :label="$t('expenses.bankReconciliation.transactions.bank')"
                  @change="handleBankChange()"
                  hide-details
                  required
                />
              </div>
              <div>
                <Select
                  size="x-large"
                  item-text="name"
                  item-value="id"
                  :items="accounts.data"
                  :disabled="isEmpty(accounts.data)"
                  v-model.lazy="account"
                  :label="$t('expenses.bankReconciliation.transactions.account')"
                  @change="handleAccountChange()"
                  hide-details
                  required
                />
              </div>
            </div>
            <v-data-table
              v-model="tableRelations.selected"
              :loading-text="tableRelations.loadingText"
              :loading="tableRelations.loading"
              :headers="tableRelations.headers"
              :items="tableRelations.data"
              :options="tableRelations.options"
              :footer-props="{
                'items-per-page-options': [5, 10, 15]
              }"
              class="data-table-style"
              >
              <template v-slot:[`item._id`]="{ item }">
                <div class="tableText">{{ item._id }}</div>
              </template>
              <template v-slot:[`item.date`]="{ item }">
                <div class="tableText">{{ $moment(item.date).format('DD/MM/YYYY') }}</div>
              </template>
              <template v-slot:[`item.updatedBy`]="{ item }">
                <div class="tableText">{{ item.updatedBy ? item.updatedBy.email : undefined }}</div>
              </template>
              <template v-slot:[`item.bankTransactionsTotal`]="{ item }">
                <a @click="openRelatedTransactionsDialog(item._id)" class="text-right tableText tableLink">
                  <span v-if="item.bankTransactions.length">
                    {{ formatCurrency(item.bankTransactionsTotal) + "(" + item.bankTransactions.length + ")" }}
                  </span>
                  <v-icon x-small>$openDialog</v-icon>
                </a>
              </template>
              <template v-slot:[`item.ordersTotal`]="{ item }">
                <a @click="openRelatedPayOrdersDialog(item)" class="text-right tableText tableLink">
                  <span v-if="item.orders.length">
                    {{ formatCurrency(item.ordersTotal) + "(" + item.orders.length + ")" }}
                  </span>
                  <v-icon x-small>$openDialog</v-icon>
                </a>
              </template>
              <template v-slot:[`item.transfersTotal`]="{ item }">
                <div v-if="item.transfers.length">
                  <a @click="openRelate+dMovementsDialog(item)" class="text-right tableText tableLink">
                    <span v-if="item.transfers.length">
                      {{ formatCurrency(item.transfersTotal) + "(" + item.transfers.length + ")" }}
                    </span>
                    <v-icon x-small>$openDialog</v-icon>
                  </a>
                </div>
                <div v-else> - </div>
              </template>
              <template v-slot:[`item.total`]="{ item }">
                <div v-if="calculateDifference(item) > 1" class="d-flex align-center">
                  <v-icon class="red-icon">mdi-alert</v-icon>
                  <div class="differenceText">
                    {{ $t('expenses.bankReconciliation.relations.tableRelations.differenceText', { difference: formatCurrency(calculateDifference(item)) }) }}
                  </div>
                </div>
                <div v-else> - </div>
              </template>
            </v-data-table>

            <RelatedTransactionsViewer ref="relatedTransactionsViewer"  v-bind:accountId="account" v-bind:bankId="bank" @updateRelations="loadRelations()" />
            <RelatedPayOrdersViewer ref="relatedPayOrdersViewer" @updateRelations="loadRelations()" />
            <RelatedMovementsViewer ref="relatedMovementsViewer" @updateRelations="loadRelations()" />

          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'
import * as XLSX from 'xlsx'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import Button from '@/components/elements/Button'
import Select from '@/components/elements/Select'
import RelateBankMovements from '@/components/sidePanels/RelateBankMovements'
import BankMovementsRelations from '@/components/sidePanels/BankMovementsRelations'
import formatCurrency from '@/utils/formatCurrency'
import RelatedTransactionsViewer from '@/components/modals/RelatedTransactionsViewer'
import RelatedPayOrdersViewer from '@/components/modals/RelatedPayOrdersViewer'
import RelatedMovementsViewer from '@/components/modals/RelatedMovementsViewer'

export default {
  name: 'BankReconciliation',
  components: {
    Button,
    Select,
    RelateBankMovements,
    BankMovementsRelations,
    vueDropzone: vue2Dropzone,
    RelatedTransactionsViewer,
    RelatedPayOrdersViewer,
    RelatedMovementsViewer
  },
  data () {
    return {
      overlay: false,
      datePicker: false,
      section: this.$i18n.t('expenses.bankReconciliation.section'),
      dates: [],
      table: {
        title: this.$i18n.t('expenses.bankReconciliation.transactions.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.headers.date'), value: 'date', sortable: true },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.headers.description'), value: 'description', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.headers.charge'), value: 'amount', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.headers.actions'), value: 'actions', sortable: false }
        ],
        data: [],
        total: 0,
        selected: [],
        options: {
          sortBy: ['date'],
          itemsPerPage: 15,
          page: 1
        }
      },
      tablePreviewTransactions: {
        title: this.$i18n.t('expenses.bankReconciliation.transactions.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.headers.date'), value: 'date', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.headers.description'), value: 'description', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.headers.charge'), value: 'amount', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.headers.payment'), value: 'amount2', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.headers.balance'), value: 'balance', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 10,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: ['date'],
          sortDesc: []
        }
      },
      tableRelations: {
        loadingText: this.$i18n.t('expenses.bankReconciliation.relations.tableRelations.loadingText'),
        loading: false,
        headers: [
          { text: this.$i18n.t('expenses.bankReconciliation.relations.tableRelations.headers.id'), value: '_id', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.relations.tableRelations.headers.date'), value: 'date', sortable: true },
          { text: this.$i18n.t('expenses.bankReconciliation.relations.tableRelations.headers.modifiedBy'), value: 'updatedBy', sortable: true },
          { text: this.$i18n.t('expenses.bankReconciliation.relations.tableRelations.headers.transactions'), value: 'bankTransactionsTotal', sortable: true },
          { text: this.$i18n.t('expenses.bankReconciliation.relations.tableRelations.headers.orders'), value: 'ordersTotal', sortable: true },
          { text: this.$i18n.t('expenses.bankReconciliation.relations.tableRelations.headers.movements'), value: 'transfersTotal', sortable: true },
          { text: '', value: 'total', sortable: false }
        ],
        data: [],
        total: 0,
        selected: [],
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 10,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: ['date'],
          sortDesc: []
        }
      },
      search: '',
      tab: null,
      banks: {
        data: [],
        loading: false
      },
      bank: null,
      accounts: {
        data: [],
        loading: false
      },
      account: null,
      transaction: null,
      relateMovementPanelOpen: false,
      movementsRelationsPanelOpen: false,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        maxFiles: 1,
        acceptedFiles: '.xls, .xlsx',
        dictDefaultMessage: 'Arrastra archivos aquí para cargarlos',
        dictFallbackMessage: 'Tu navegador no tiene soporte para subir archivos arrastrando.',
        dictFallbackText: 'Por favor usa el formulario de reserva de abajo para subir tus archivos como antes.',
        dictFileTooBig: 'Tamaño de archivo es demasiado grande ({{filesize}}MiB). Tamaño de archivo máximo: {{maxFilesize}}MiB.',
        dictInvalidFileType: 'No se pueden subir archivos de este tipo.',
        dictResponseError: 'El servidor respondió con un código de estatus {{statusCode}}.',
        dictCancelUpload: 'Cancelar carga',
        dictCancelUploadConfirmation: '¿Estás seguro de cancelar esta carga?',
        dictRemoveFile: 'Quitar archivo',
        dictMaxFilesExceeded: 'No se pueden subir más archivos.'
      },
      uploadDialogOpen: false,
      transactionsData: [],
      previewDialogOpen: false,
      uploadErrorDialogOpen: false,
      uploadSuccessDialogOpen: false,
      warningDialogOpen: false,
      relatedTransactionsDialogOpen: false,
      relatedPayOrdersDialogOpen: false,
      relatedMovementsDialogOpen: false,
      buttonRelateMovement: false,
      buttonRelateCategory: false
    }
  },
  mounted () {
    this.loadBanks()
  },
  computed: {
    restaurant () {
      return this.$store.state.currentRestaurant.data
    },
    hasFinerioAccount () {
      const selectedBank = this.banks.data.find(item => item._id === this.bank)
      return !!selectedBank.credentialId
    },
    totalAmountSelected () {
      return this.table.selected.reduce((acc, curr) => acc + curr.amount, 0)
    },
    range () {
      const dates = this.dates
      return dates.length < 2 ? '' : `${dates[0]} / ${dates[1]}`
    },
    bankReconciliationPermissions () {
      return this.$store.state.login.permissions['expenses'].components['financial-movements'].actions
    }
  },
  watch: {
    'search': async function (val) {
      const params = {}
      if (val.length >= 3) {
        try {
          params.q = `/${val}/i`
          await this.load(params)
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      } else {
        this.load(params)
      }
    },
    tab: async function (val) {
      if (val === 0) {
        this.bank && (!this.hasFinerioAccount || this.account) && this.loadBankTransactions()
      } else if (val === 1) {
        this.bank && (!this.hasFinerioAccount || this.account) && this.loadRelations()
      }
    },
    // 'table.data': function () {
    //   this.table.selected = []
    // },
    '$store.state.currentRestaurant.data': async function (val) {
      this.resetForm()
      await this.loadBanks()
    }
  },
  methods: {
    allowedDates (val) {
      return this.$moment(val).isSameOrBefore(new Date())
    },
    resetForm () {
      this.table.data = []
      this.table.total = 0
      this.table.selected = []
      this.tablePreviewTransactions.data = []
      this.tablePreviewTransactions.total = 0
      this.tableRelations.data = []
      this.tableRelations.total = 0
      this.tableRelations.selected = []
      this.banks.data = []
      this.banks.loading = false
      this.bank = null
      this.accounts.data = []
      this.accounts.loading = false
      this.account = null
      this.transaction = null
      this.relateMovementPanelOpen = false
      this.movementsRelationsPanelOpen = false
      this.uploadDialogOpen = false
      this.transactionsData = []
      this.previewDialogOpen = false
      this.uploadErrorDialogOpen = false
      this.uploadSuccessDialogOpen = false
      this.warningDialogOpen = false
      this.relatedTransactionsDialogOpen = false
      this.relatedPayOrdersDialogOpen = false
      this.relatedMovementsDialogOpen = false
    },
    async loadBanks (params = null) {
      params = params || {
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.banks.loading = true
      try {
        const response = await this.$api.get(`/v1/financial/balance-accounts`, params)
        this.banks.data = response
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.banks.loading = false
    },
    async loadBankAccounts (params = null) {
      params = params || {
        credentialId: this.banks.data.find(item => item._id === this.bank).credentialId
      }
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/banks/accounts`, params)
        this.accounts = response
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async loadBankTransactions (params = null) {
      params = {
        bank: this.bank,
        accountId: this.account || undefined,
        isCharge: 'true',
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.page - 1)),
        sort: this.table.options.sortDesc && this.table.options.sortDesc[0] ? this.table.options.sortBy[0] : `-${this.table.options.sortBy[0] || 'date'}`,
        ...params
      }
      if (this.dates.length === 2) {
        const dates = [this.dates[0], this.dates[1]].sort((a, b) => {
          if (a > b) return 1
          if (a < b) return -1
          return 0
        })
        params.startDate = this.$moment(dates[0]).startOf('day').toISOString()
        params.endDate = this.$moment(dates[1]).endOf('day').toISOString()
        this.datePicker = false
      }
      this.table.loading = true
      try {
        const response = await this.$api.get(`/v1/banks/transactions`, params)
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    async resetDate () {
      this.dates = []
      this.datePicker = false
    },
    updateTable: async function (data) {
      const { sortBy, sortDesc } = data
      if (this.bank) {
        this.table.options.sortDesc = [sortDesc[0]]
        this.table.options.sortBy = [sortBy[0]]
        this.table.options.page = data.page
        await this.loadBankTransactions({
          bank: this.bank,
          accountId: this.account || undefined,
          isCharge: 'true',
          limit: data.itemsPerPage,
          skip: (data.itemsPerPage * (data.page - 1)),
          sort: `${sortDesc[0] ? '' : '-'}${sortBy[0]}`
        })
      }
    },
    openRelateMovementPanel (item, buttonRelateMovement, buttonRelateCategory) {
      this.transaction = [item]
      if (buttonRelateMovement) this.buttonRelateMovement = true
      if (buttonRelateCategory) this.buttonRelateCategory = true
      this.relateMovementPanelOpen = true
    },
    closeRelateMovementPanel (item) {
      this.buttonRelateMovement = false
      this.buttonRelateCategory = false
      this.relateMovementPanelOpen = false
    },
    openMovementsRelationsPanel (item) {
      this.transaction = item
      this.movementsRelationsPanelOpen = true
    },
    closeMovementsRelationsPanel (item) {
      this.movementsRelationsPanelOpen = false
    },
    reset () {
      this.transaction = null
      this.table.selected = []
    },
    openUploadDialog () {
      this.uploadDialogOpen = true
    },
    openTransactionsDialog (buttonRelateMovement, buttonRelateCategory) {
      this.transaction = this.table.selected
      if (buttonRelateMovement) this.buttonRelateMovement = true
      if (buttonRelateCategory) this.buttonRelateCategory = true
      this.relateMovementPanelOpen = true
    },
    closeUploadDialog (item) {
      this.uploadDialogOpen = false
      this.$refs.myVueDropzone.removeAllFiles(true)
    },
    saveFile () {
      this.relateTransactions()
    },
    openPreviewDialog (file, res) {
      const reader = new FileReader()
      reader.onload = ({ target }) => {
        const data = new Uint8Array(target.result)
        const workbook = XLSX.read(data, { type: 'array' })
        const [firstSheetName] = workbook.SheetNames
        const worksheet = workbook.Sheets[firstSheetName]
        const fileData = XLSX.utils.sheet_to_json(worksheet, { header: 22 })

        this.tablePreviewTransactions.data = fileData.map(item => {
          return Object.assign(item, {
            'Fecha del apunte': this.formatDate(item['Fecha del apunte'])
          })
        })
      }

      reader.readAsArrayBuffer(file)

      this.previewDialogOpen = true
    },
    isValidDate () {
      return this.tablePreviewTransactions.data.some(item => item['Fecha del apunte'] === 'Error en la fecha')
    },
    formatDate (item) {
      if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(item)) return this.$moment(this.excelDateToJSDate(item)).format('YYYY/MM/DD')
      const reversedDate = item.split('/').reverse().join('/')
      if (this.$moment(reversedDate).isValid()) {
        const formattedDate = this.$moment(reversedDate).format('YYYY/MM/DD')
        return formattedDate
      }
      if (this.$moment(item).isValid()) {
        const formattedDate = this.$moment(item).format('YYYY/MM/DD')
        return formattedDate
      }

      return 'Error en la fecha'
    },
    closePreviewDialog () {
      this.$refs.myVueDropzone.removeAllFiles(true)
      this.tablePreviewTransactions.data = []
      this.previewDialogOpen = false
    },
    async relateTransactions (params = null) {
      if (!this.isValidDate()) {
        const payload = {
          restaurant: this.restaurant._id,
          bank: this.bank,
          transactions: this.tablePreviewTransactions.data.map(item => ({
            description: item['Descripción'],
            amount: Math.abs(item['Importe de crédito'] || item['Importe del débito']),
            isCharge: `${!!item['Importe del débito']}`,
            date: item['Fecha del apunte'],
            balance: `${item['Saldo']}`,
            currency: item['Moneda']
          }))
        }
        this.overlay = true
        try {
          await this.$api.post(`/v1/banks/transactions`, payload)
          this.loadBankTransactions()
          this.openUploadSuccessDialog()
        } catch (error) {
          this.openUploadErrorDialog()
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      } else {
        this.$toasted.show('Hay error en los formatos de fecha, el formato válido es: AÑO/MES/DIA ejemplo 2021/11/25', { duration: 4000 })
      }
    },
    openUploadErrorDialog () {
      this.uploadErrorDialogOpen = true
    },
    closeUploadErrorDialog () {
      this.closePreviewDialog()
      this.uploadErrorDialogOpen = false
    },
    openUploadSuccessDialog () {
      this.uploadSuccessDialogOpen = true
    },
    closeUploadSuccessDialog () {
      this.closePreviewDialog()
      this.closeUploadDialog()
      this.uploadSuccessDialogOpen = false
    },
    excelDateToJSDate (serial) {
      const date = new Date((serial - (25567 + 1)) * 86400 * 1000)
      return date.toISOString()
    },
    isEmpty,
    openWarningDialog () {
      this.warningDialogOpen = true
    },
    closeWarningDialog () {
      this.warningDialogOpen = false
    },
    completeTransactions: async function () {
      this.overlay = true
      try {
        this.loadBankTransactions()
        this.closeWarningDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    formatCurrency,
    openRelatedTransactionsDialog (relationId) {
      this.$refs.relatedTransactionsViewer.openDialog(relationId)
    },
    openRelatedPayOrdersDialog (relation) {
      this.$refs.relatedPayOrdersViewer.openDialog(relation)
    },
    openRelatedMovementsDialog (relation) {
      this.$refs.relatedMovementsViewer.openDialog(relation)
    },
    loadRelations: async function () {
      this.tableRelations.loading = true
      const params = {
        restaurant: this.restaurant._id,
        bank: this.bank,
        finerioUnitAccount: this.account || undefined
      }
      try {
        const response = await this.$api.get(`/v1/bank-reconciliation`, params)
        this.tableRelations.data = response.data
        this.tableRelations.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.tableRelations.loading = false
    },
    handleBankChange: async function () {
      this.account = null
      this.accounts.data = []
      this.table.data = []

      if (this.hasFinerioAccount) {
        await this.loadBankAccounts()
      } else {
        if (this.tab === 0) {
          await this.loadBankTransactions()
        } else if (this.tab === 1) {
          await this.loadRelations()
        }
      }
    },
    handleAccountChange: async function () {
      this.table.data = []

      if (this.tab === 0) {
        await this.loadBankTransactions()
      } else if (this.tab === 1) {
        await this.loadRelations()
      }
    },
    calculateDifference (relation) {
      return Math.abs(relation.bankTransactionsTotal - relation.total)
    }
  }
}
</script>

<style lang="scss" scoped>
  .colorButton {
    background-color: #2196F3 !important;
  }

  .sectionTitle {
    font-size: 34px;
    font-weight: bold;
    line-height: 40px;
    color: #646464;
  }

  .paper {
    display: flex;
    padding: 40px 50px 50px 57px;
    border-radius: 26px;
    background-color: #fff;
    flex-direction: column;
    align-items: center;
  }

  .tab {
    font-size: 12px;
  }

  .tabs-items {
    width: 100%;
  }

  .firstSelect {
    margin-right: 52px;
  }

  .v-application .v-data-table th {
    font-weight: 500;
    color: #ACABAB;
  }

  .v-application .v-data-table td {
    font-weight: 500;
    color: #646464;
  }

  .v-pagination__navigation {
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .v-pagination__item {
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #A4A6AB !important;
  }

  .v-pagination__item--active {
    color: #fff !important;
  }

  .footer {
    font-size: 12px;
    color: #A4A6AB;
  }

  .footerText {
    margin-right: 12px;
    margin-top: auto;
    margin-bottom: auto;
  }

  .footerSelect {
    width: 30px;
    padding-top: 0px;
    margin-top: 0px;
    color: #A4A6AB;
  }
  .footerSelect.v-text-field>.v-input__control>.v-input__slot:before {
    border-style: none;
  }
  .footerSelect.v-text-field>.v-input__control>.v-input__slot:after {
      border-style: none;
  }

  .footerSelect .v-select__selections {
    color: #A4A6AB !important;
  }

  .successIcon {
    width: 84px;
  }

  #dropzone {
    border-style: dashed;
    min-height: 20rem;
    display: flex;
    justify-content: center;
    font-size: 16px;
  }
  .data-table-style {
    .th {
      .v-data-table__checkbox {
        display:none !important;
      }
    }
  }

  .buttonCompleted {
    margin-left: 8px;
    background-color: #0F6FFF !important;
  }

  .alert-icon {
    font-size: 6.25rem !important;
    color: #DF2D2D !important;
  }

  .dialogText {
    font-size: 1.285rem;
    line-height: 1.25;
    margin-bottom: 0;
    font-size: 1.125rem;
    line-height: 24.24px;
  }

  .red-icon {
    margin-right: 9px;
    color: #FF1A1A;
    font-size: 16px;
  }

  .tableText {
    font-weight: 500;
    font-size: 12px;
  }

  .tableLink {
    display: flex;
    align-items: center;
    word-break: keep-all;

    &:hover {
      color: #0F6FFF !important;
      text-decoration: underline;
    }
  }

  .differenceText {
    font-weight: 500;
    font-size: 12px;
  }
</style>

<style>
  .custom-dialog .v-dialog .v-card {
    border-style: dashed;
  }
  .v-dialog {
    border-radius: 22px;
  }
  .v-dialog > .v-card > .v-card__actions {
    padding: 0 16px 12px;
  }
</style>
